export default __webpack_public_path__ + "static/media/short-logo.47c6ad90.png";